import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { fetchLinkPreview } from './chatApi'

/** Links are only fetched once typing settles. */
const SETTLE_DELAY_MS = 400

/**
 * What the composer's first link is — its title and image — for its Link preview. The
 * server unfurls it, since a browser can't fetch another site's page; the stream's
 * preview comes from the server too, after the send. Null data until the link settles
 * and its preview arrives; a link that fails to unfurl stays without one.
 */
export const useComposerLinkPreview = (tripId: string, link: string | null) => {
	const [settled, setSettled] = useState<string | null>(null)

	useEffect(() => {
		if (!link) {
			setSettled(null)
			return
		}
		const timer = setTimeout(() => setSettled(link), SETTLE_DELAY_MS)
		return () => clearTimeout(timer)
	}, [link])

	const shown = settled === link ? settled : null
	return useQuery({
		queryKey: queryKeys.chatLinkPreview(tripId, shown),
		queryFn: () => fetchLinkPreview(tripId, shown ?? ''),
		enabled: shown !== null,
		staleTime: Infinity,
		retry: false,
	})
}
